import { createFileRoute } from "@tanstack/react-router";

import { StaticPage } from "@/components/site-footer";
import { loadSiteContent, useSiteContent } from "@/lib/content";
import { pageMeta, pageTitle } from "@/lib/seo";

import { publicPageHeaders } from "./-public-cache";

export const Route = createFileRoute("/privacy")({
  // already in the cache from the root route; here for the page's title and description
  loader: ({ context }) => loadSiteContent(context.queryClient),
  head: ({ loaderData }) => ({
    meta: pageMeta(
      pageTitle(loaderData?.privacyPage.title ?? "حریم خصوصی"),
      loaderData?.privacyPage.metaDescription,
    ),
  }),
  headers: publicPageHeaders,
  component: PrivacyPage,
});

function PrivacyPage() {
  return <StaticPage page={useSiteContent().privacyPage} />;
}
